import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
// import Inventory from '../legacy/pages/Inventory';
import Inventory from '../views/pages/InventoryView';
import InventoryImpPhase1 from '../views/pages/InventoryView/InventoryViewOld';
import ROUTE_PATH from './routePaths';

const routes = [
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATH.INVENTORY_LMP,
    component: props => (
      <ContentWithNavigationSidebar>
        <Inventory {...props} />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATH.INVENTORY_IMP,
    component: props => (
      <ContentWithNavigationSidebar>
        <InventoryImpPhase1 {...props} />
      </ContentWithNavigationSidebar>
    ),
  },
  /* {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATH.REPORTS}/:reportId`,
    component: props => (
      <ContentWithNavigationSidebar>
        <ReportsReport {...props} />
      </ContentWithNavigationSidebar>
    ),
  }, */
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes/inventory.jsx